var $name="shell/registry/ComponentContext",$path="app/modules/shell/registry/ComponentContext.js",$this={$name,$path,};import VisualContext from './VisualContext';

export default class ComponentContext extends VisualContext {}
